import { render, staticRenderFns } from "./ModalItemProduct.vue?vue&type=template&id=46f58808&scoped=true&"
import script from "./ModalItemProduct.vue?vue&type=script&lang=js&"
export * from "./ModalItemProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemProduct.vue?vue&type=style&index=0&id=46f58808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f58808",
  null
  
)

export default component.exports